import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Image, Row, Dropdown, Spinner, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useUser from '../useUser';
import trainer from 'assets/img/e-learning/avatar/trainer.png';
import Avatar from 'components/common/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UploadFiles from 'components/common/UploadFiles';
import Input from 'components/common/Input';
import Flex from 'components/common/Flex';
import { useForm } from 'react-hook-form';
import Socials from 'components/common/Socials';
import IconButton from 'components/common/IconButton';
import { validateURL } from 'helpers/utils';
import ChangePassword from './ChangePassword';
import FalconCloseButton from 'components/common/FalconCloseButton';

const descp = [
 'Milton Finger (born February 8, 1914), better known as Bill Finger, was an American comic strip, comic book, film, and television writer who co-created the DC Comics superhero character Batman (along with Bob Kane).',
 "A young, promising writer and part-time shoe dealer Finger, joined Kane's fledgling studio in 1938. Despite his significant (and often iconic) contributions as an imaginative writer, visionary mythos/world builder, and illustration creator, Finger was frequently reduced to ghostwriter status on a number of comics, including Batman and Green Lantern (Original Version).",
 'In 1994, Finger was welcomed into the Jack Kirby Hall of Fame, and in 1999, he was inducted into the Will Eisner Award Hall of Fame. In 1985, the company recognised Finger as one of the awardees in their 50th anniversary edition of Fifty Who Made DC Great. In 2014, Finger was posthumously awarded The Inkpot Award.'
];

const UserSettings = () => {
 const navigate = useNavigate();

 const { isLoading, data, onError, onSubmitData, configDispatch } = useUser();

 const [formData, setFormData] = useState({
  viewProfile: 'my-followers',
  tagSettings: 'group-members',
  showFollowers: true,
  showEmail: true,
  showExperience: false,
  numberVisibility: true,
  allowFollow: false
 });

 const handleChange = e => {
  if (e.target.type === 'checkbox') {
   setFormData({
    ...formData,
    [e.target.name]: e.target.checked
   });
  } else {
   setFormData({
    ...formData,
    [e.target.name]: e.target.value
   });
  }
 };

 const {
  watch,
  reset,
  register,
  setValue,
  handleSubmit,
  formState: { errors }
 } = useForm({ defaultValues: { socials: [], description: descp, photo: null, ...data } });

 const [photo, setPhoto] = useState(data?.photo || trainer);
 const [modal, setModal] = useState(false);

 useEffect(() => {
  configDispatch({
   type: 'RESTORE',
   payload: { tem: true, isFluid: true, navbarPosition: 'top', disabledNavbarPosition: ['vertical', 'combo'] }
  });
 }, []);

 useEffect(() => {
  //console.log(data, 'datos de consulta');
  if (data) {
   reset(data);
   setPhoto(data?.photo || trainer);
  }
 }, [data]);

 /* useEffect(() => {
  const subscription = watch((value, { name }) => {
   console.log(value, 'el formulario cambio', name);
  });
  return () => subscription.unsubscribe();
 }, [watch]); */

 return (
  data && (
   <>
    <Form noValidate onSubmit={handleSubmit(onSubmitData, onError)}>
     <Row className="g-3">
      <Col lg={4} xl={3}>
       <div className="sticky-sidebar top-navbar-height">
        <Card>
         <Card.Body>
          <Row className="g-3 align-items-center">
           <Col md={6} lg={12} className="text-center position-relative mb-3">
            <Image src={photo} alt="trainer" fluid className="rounded-3" />

            <UploadFiles
             preview={false}
             className="mb-2"
             multiple={false}
             accept="image/*"
             dropzoneArea={false}
             style={{ maxHeight: 300 }}
             onChange={e => {
              setValue('photo', !e?.length ? null : e);
              setPhoto(e?.length ? e[0]?.base64 : trainer);
             }}
             placeholder={
              <Button
               variant="falcon-primary"
               type="button"
               className="m-3 icon-item icon-item-sm position-absolute top-0 end-0 z-index-1"
              >
               <FontAwesomeIcon icon="pencil-alt" />
              </Button>
             }
            />

            <div className="ms-3 pb-4 position-absolute top-100 start-0 translate-middle-y z-index-1">
             <Avatar
              uploader
              size="4xl"
              src={watch('avatar')}
              mediaClass="img-thumbnail shadow-sm"
              propUploader={{
               iconClass: 'me-0',
               classInput: 'logo5',
               register: register('avatar', { required: 'El logo es requerido' }),
               onChange: img => setValue('avatar', img, { shouldValidate: true, shouldTouch: true }),
               multiple: false
              }}
             />
            </div>
           </Col>
           <Col md={6} lg={12}>
            <Row className="row-cols-1 g-0">
             <Col className="">
              <div className="border-dashed border-bottom my-3" />

              <div className="ps-2">
               <Form.Check
                type="checkbox"
                id="show-followers"
                label="Allow users to show your followers"
                className="form-label-nogutter"
                name="showFollowers"
                onChange={handleChange}
                checked={formData.showFollowers}
               />
               <Form.Check
                type="checkbox"
                id="show-email"
                label="Allow users to show your email"
                className="form-label-nogutter"
                name="showEmail"
                onChange={handleChange}
                checked={formData.showEmail}
               />
               <Form.Check
                type="checkbox"
                id="show-experience"
                label="Allow users to show your experiences"
                className="form-label-nogutter"
                name="showExperience"
                onChange={handleChange}
                checked={formData.showExperience}
               />
              </div>

              <div className="border-dashed border-bottom my-3" />

              <div className="ps-2">
               <Form.Check
                type="switch"
                id="custom-switch"
                label="Make your phone number visible"
                className="form-label-nogutter"
                name="numberVisibility"
                onChange={handleChange}
                checked={formData.numberVisibility}
               />
               <Form.Check
                type="switch"
                id="custom-switch"
                label="Allow user to follow you"
                className="form-label-nogutter"
                name="allowFollow"
                onChange={handleChange}
                checked={formData.allowFollow}
               />
              </div>
             </Col>
            </Row>
           </Col>
          </Row>
         </Card.Body>
        </Card>
       </div>
      </Col>
      <Col lg={8} xl={9}>
       <Card className="mb-3">
        <Card.Header className="d-flex flex-between-center">
         <IconButton onClick={() => navigate(-1)} variant="falcon-default" size="sm" icon="arrow-left" />
         <Flex>
          <IconButton
           //onClick={handleShow}
           variant="falcon-default"
           size="sm"
           icon="tasks"
           transform="shrink-2"
           iconAlign="middle"
           className="d-xl-none"
          >
           <span className="ms-1">To-do</span>
          </IconButton>

          <div className="bg-300 mx-3 d-xl-none" style={{ width: '1px', height: '29px' }}></div>

          <IconButton variant="falcon-default" size="sm" icon="sync-alt" iconAlign="middle" className="d-none d-sm-block">
           <span className="d-none d-xl-inline-block ms-1">Convertir en Agente</span>
          </IconButton>
          <IconButton variant="falcon-default" size="sm" icon="lock" iconAlign="middle" className="d-none d-sm-block mx-2">
           <span className="d-none d-xl-inline-block ms-1">Confirmar Email</span>
          </IconButton>
          <IconButton
           variant="falcon-default"
           size="sm"
           icon="key"
           iconAlign="middle"
           className="d-none d-sm-block me-2"
           onClick={() => setModal(true)}
          >
           <span className="d-none d-xl-inline-block ms-1">Cambiar Contraseña</span>
          </IconButton>
          <IconButton variant="falcon-default" size="sm" icon="trash-alt" iconAlign="middle" className="d-none d-sm-block me-2">
           <span className="d-none d-xl-inline-block ms-1">Eliminar Cuenta</span>
          </IconButton>
          <Dropdown align="end" className="btn-reveal-trigger d-inline-block">
           <Dropdown.Toggle split variant="falcon-default" size="sm">
            <FontAwesomeIcon icon="ellipsis-v" className="fs--2" />
           </Dropdown.Toggle>

           <Dropdown.Menu className="border py-0">
            <div className="py-2">
             <Dropdown.Item>Ver Perfil</Dropdown.Item>
             <Dropdown.Item className="d-sm-none">Convertir en Agente</Dropdown.Item>
             <Dropdown.Item className="d-sm-none">Confirmar Email</Dropdown.Item>
             <Dropdown.Item className="d-sm-none" onClick={() => setModal(true)}>
              Cambiar Contraseña
             </Dropdown.Item>
             <Dropdown.Divider className="d-sm-none" />
             <Dropdown.Item className="text-danger d-sm-none">Eliminar Cuenta</Dropdown.Item>
            </div>
           </Dropdown.Menu>
          </Dropdown>
         </Flex>
        </Card.Header>
        <Card.Body>
         <Row className="flex-between-center g-3">
          <Input
           type="text"
           label="Nombre*"
           name="fullName"
           errors={errors}
           placeholder="Nombre para mostrar"
           formLabelProps={{ className: 'mb-0 fs--1' }}
           formGroupProps={{ as: Col, lg: 4 }}
           formControlProps={{
            ...register('fullName', { required: true, validate: value => !/[^a-zA-Z0-9_-ñ Ñ]/g.test(value) || false }),
            autoComplete: 'off',
            size: 'sm'
           }}
          />
          <Input
           type="text"
           label="Profesión*"
           name="profession"
           errors={errors}
           placeholder="Profesión u ocupación"
           formLabelProps={{ className: 'mb-0 fs--1' }}
           formGroupProps={{ as: Col, lg: 4 }}
           formControlProps={{
            ...register('profession', { required: true, validate: value => !/[^a-zA-Z0-9_-ñ Ñ]/g.test(value) || false }),
            autoComplete: 'off',
            size: 'sm'
           }}
          />
          <Input
           type="text"
           label="Email*"
           name="email"
           errors={errors}
           placeholder="Emaill de inisio de sesion"
           formLabelProps={{ className: 'mb-0 fs--1' }}
           formGroupProps={{ as: Col, lg: 4 }}
           formControlProps={{
            ...register('email', {
             required: true,
             pattern: {
              value: /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/i,
              message: 'Email invalido'
             }
            }),
            autoComplete: 'off',
            size: 'sm'
           }}
          />
         </Row>
        </Card.Body>
       </Card>

       <Card>
        <Card.Header className="bg-light">
         <h6 className="mb-0">Introduction</h6>
        </Card.Header>
        <Card.Body>
         <Row className="flex-between-center">
          <Col xxl={9} className="text-1000">
           <Input
            type="textarea"
            label="Parrafo 1"
            name="description.0"
            errors={errors}
            placeholder="Crea una descripción en esta primera parte"
            formLabelProps={{ className: 'mb-0 fs--1' }}
            formGroupProps={{ className: 'w-100 mb-3' }}
            formControlProps={{ ...register('description.0', { minLength: 100 }), size: 'sm', rows: 2 }}
           />

           <Input
            type="textarea"
            label="Parrafo 2"
            name="description.1"
            errors={errors}
            placeholder="Continua con la descripción en esta segunda parte"
            formLabelProps={{ className: 'mb-0 fs--1' }}
            formGroupProps={{ className: 'w-100 mb-3' }}
            formControlProps={{ ...register('description.1', { minLength: 100 }), size: 'sm', rows: 3 }}
           />

           <Input
            type="textarea"
            label="Parrafo 3"
            name="description.2"
            errors={errors}
            placeholder="Continua con la descripción en esta tercera parte"
            formLabelProps={{ className: 'mb-0 fs--1' }}
            formGroupProps={{ className: 'w-100' }}
            formControlProps={{ ...register('description.2', { minLength: 100 }), size: 'sm', rows: 3 }}
           />
          </Col>
          <Col xxl={3}>
           <Input
            type="hidden"
            formControlProps={{ ...register('socials', { validate: value => !value.some(e => e.url && !validateURL(e.url)) }) }}
           />
           <Flex justifyContent="center" className="mt-4 mt-xxl-0">
            <Socials watch={watch} errors={errors} setValue={setValue} smHiden={true} />
           </Flex>
          </Col>
         </Row>
        </Card.Body>
        <Card.Footer className="border-top">
         {isLoading && <Spinner animation="border" variant="primary" className="ms-md-3 my-auto float-start" />}
         <IconButton
          size="sm"
          type="submit"
          icon="sync-alt"
          iconAlign="middle"
          transform="shrink-2"
          variant="falcon-primary"
          className="float-end me-md-3"
         >
          <span className="ms-1">Actualizar Datos</span>
         </IconButton>
        </Card.Footer>
       </Card>
      </Col>
     </Row>
    </Form>

    <Modal
     size="sm"
     show={modal}
     onHide={() => setModal(false)}
     backdrop="static"
     keyboard={false}
     aria-labelledby="example-modal-sizes-title-sm"
    >
     <Modal.Header>
      <Modal.Title id="example-modal-sizes-title-sm">Change Password</Modal.Title>
      <FalconCloseButton onClick={() => setModal(false)} />
     </Modal.Header>
     <Modal.Body>
      <ChangePassword onSubmitData={onSubmitData} onError={onError} isLoading={isLoading} />
     </Modal.Body>
    </Modal>
   </>
  )
 );
};

export default UserSettings;
